const components = []

export default {
  register(component) {
    components.push(component)
  },
  emit(event) {
    components.forEach(component => component(event))
  }
}